<!-- The Maven panel chassis (CR-20260910-001 milestone 4, lane S6).
     Three columns, per the wireframe (01-feature-request.md section 5.1): Setup | Results | Details.
     The active-panel gate matches every other panel: [ngClass]="{'ets-hidden': !isActive}". -->
<div [ngClass]="{'ets-hidden': !this.isActive}" class="panel-container" data-element="maven-panel">

  <div class="maven-root" #mavenRoot>

    <!-- LEFT — Setup. Lane S6. The Kanban THE SETUP column is the definition of this column. The
         sketch's zone HEADER is dropped (ruling Q4) and there is NO OVERRIDE ZONE; since
         2026-09-14 the portfolio's current zone is shown as a read-only line inside the Setup's
         portfolio section (owner vrequest, replacing Q4's "the footer shows it"). The sections
         land here in build order U3-U8. -->
    <section class="maven-column maven-column--setup" data-element="maven-setup-column">
      <!-- Column header. A LABEL, not a collapse toggle: the collapsible sections are the ones
           inside the Setup. -->
      <div class="maven-column-head" data-element="maven-column-head-setup">Setup</div>
      <!-- panelInstanceId is the SUPERSEDE SCOPE, with the terminal: one Maven panel instance
           runs one run at a time, and a second Apply displaces the first. The panel owns the id
           because the panel is the instance. -->
      <!-- ⚠ THE OUTPUTS ARE THE FIX. This tag carried only the input, so the result of a run never
           left this component and the other two columns had nothing to render. -->
      <ets-maven-setup [panelInstanceId]="this.panelId"
                       (runningChange)="this.onRunningChange($event)"
                       (stagesChange)="this.onStagesChange($event)"
                       (runSettled)="this.onRunSettled($event)"
                       (portfolioChange)="this.onPortfolioChange($event)"></ets-maven-setup>
    </section>

    <!-- MIDDLE — Results. Lane S7 fills <ets-maven-results>. Registered in maven.module.ts from
         this same commit so S7 never has to edit this template or that module to light it up. -->
    <section class="maven-column maven-column--results" data-element="maven-results-column">
      <div class="maven-column-head" data-element="maven-column-head-results">Results</div>
      <!-- ⚠ THIS TAG HAD NO BINDINGS AT ALL, which is why a run that delivered five cards showed an
           empty column: `delivery` was permanently null. `topN` is a DISPLAY limit and null is a
           legitimate value meaning no limit. -->
      <ets-maven-results [running]="this.running"
                         [delivery]="this.delivery"
                         [topN]="this.topN"
                         [getNormFactor]="this.getNormFactor"
                         (cardPicked)="this.onCardPicked($event)"></ets-maven-results>
    </section>

    <!-- RIGHT — Details for the selected card. Lane S7 fills <ets-maven-details>. Same seam rule. -->
    <section class="maven-column maven-column--details" data-element="maven-details-column">
      <!-- No column bar here (owner, 2026-09-11): the three sections inside carry their own
           Setup-style bars and stack in the column; a fourth bar above them was noise. -->
      <!-- Same defect, same fix: the selected card, the run-level facts both order pop-ups need,
           and the portfolio they are opened against. -->
      <ets-maven-details [card]="this.selectedCard"
                         [delivery]="this.delivery"
                         [portfolio]="this.portfolio"></ets-maven-details>
    </section>

  </div>

  <!-- Running: the house spinner (owner, 2026-09-13), SHADED over the WHOLE panel — all three
       columns are blocked until the delivery lands. The stages are still tracked; the latest one
       reached is named in the spinner's text. No number appears here, ever (ruling L28). -->
  <dx-load-panel [visible]="this.running"
                 [shading]="true"
                 [message]="this.runningMessage"
                 [width]="420"
                 [position]="{my: 'center', at: 'center', of: mavenRoot}"
                 [container]="mavenRoot"
                 data-element="maven-run-spinner"></dx-load-panel>

</div>
